import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody40.css';

import clientimg from '../images/case-study-client40.webp'
import outcome from '../images/outcome40.webp'

import sm1 from '../images/cs40so1.webp'
import sm2 from '../images/cs40so2.webp'
import sm3 from '../images/cs40so3.webp'
import sm4 from '../images/cs40so4.webp'





const Casestudybody40 = () => {

    return (
        <>
        <section className='casestudybody40-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A mid-market size PE firm managing multi-family real estate assets, targeting properties with operational upside and stable income, with a portfolio of 14+ acquisitions and 10+ realized exits </p>
                    </div>
                  </div>      
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client sought a preliminary assessment of the target's financial viability, risk exposure, and strategic fit as part of evaluating a broker-marketed real estate asset positioned as an opportunistic investment</p>
                </div>               
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody40-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Data Collection and Review: </h4>
                          <p>Gathered <span style={{color:"#03A393",fontWeight:700}}> financial and operational data </span> from the broker, including property-level documents, revenue and cost details, and disclosures necessary for deal evaluation</p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Preliminary Financial Assessment: </h4>
                          <p>Performed initial <span style={{color:"#03A393",fontWeight:700}}> analysis to estimate projected cash flows, internal rate of return (IRR), and other financial indicators</span> to evaluate the property's viability and alignment with client's return requirements</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Assumption and Risk Analysis:</h4>
                          <p>Reviewed the assumptions within the <span style={{color:"#03A393",fontWeight:700}}> deal model and assessed key risk factor</span> such as lease terms, occupancy variability, and market positioning to gauge negative exposure</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Strategic Fit Evaluation:</h4>
                          <p>Analyzed the <span style={{color:"#03A393",fontWeight:700}}> asset's compatibility with the client's investment thesis,</span> considering location dynamics, and operational scalability within the broader portfolio context</p>
                        </div>
                      </div>

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Key Issues Identification:</h4>
                          <p>Documented <span style={{color:"#03A393",fontWeight:700}}> key findings, inconsistencies, and questions for a follow-up</span> with the broker and client, focusing on areas such as data reliability, valuation inputs, and risk exposure</p>
                        </div>
                      </div>                 

                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <div>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        </div>
                        <img src={sm4} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody40-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>Conducted a review that ensured data integrity and flagged key financial and operational red flags. The client leveraged these insights to renegotiate deal terms and strengthen risk mitigation measures</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody40
